if (!customElements.get('offer-card')) {
  class OfferCard extends HTMLElement {
    constructor() {
      super();
      this.unsubscribeCart = null;
    }

    connectedCallback() {
      this.progressThreshold = parseInt(this.dataset.progress, 10);
      this.cartTotal = parseInt(this.dataset.cartTotal, 10);
      this.currencySymbol = this.dataset.currencySymbol || '$';

      this.update(this.cartTotal);

      this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const freeGiftIds = new Set(
              (this.dataset.freeGiftIds || '').split(',').filter(Boolean).map(Number)
            );
            const adjusted = cart.items.reduce((sum, item) => {
              return freeGiftIds.has(item.product_id) ? sum : sum + item.final_line_price;
            }, 0);
            this.update(adjusted);
          });
      });
    }

    disconnectedCallback() {
      if (this.unsubscribeCart) {
        this.unsubscribeCart();
      }
    }

    formatCurrency(cents) {
      if (cents % 100 === 0) {
        return `${this.currencySymbol}${cents / 100}`;
      }
      return `${this.currencySymbol}${(cents / 100).toFixed(2)}`;
    }

    update(cartTotalCents) {
      if (this.progressThreshold <= 0) {
        this.classList.add('is-success');
        return;
      }
      const remaining = this.progressThreshold - cartTotalCents;
      const percentage = Math.min((cartTotalCents / this.progressThreshold) * 100, 100);

      const fillEl = this.querySelector('[data-offer-fill]');
      if (fillEl) fillEl.style.width = `${percentage}%`;

      if (remaining <= 0) {
        this.classList.add('is-success');
      } else {
        this.classList.remove('is-success');
        const copyEl = this.querySelector('[data-offer-copy]');
        if (copyEl && copyEl.dataset.template) {
          copyEl.textContent = copyEl.dataset.template.replace('{amount}', this.formatCurrency(remaining));
        }
      }
    }
  }

  customElements.define('offer-card', OfferCard);
}
